import {ReactElement} from "react";
import {RendererProps} from "../RendererProps";
import {formatYearAndVersionType} from "../common";
import {Account} from "../../../../../contexts/chartofaccounts/ChartOfAccountsContext";
import {RenderPendingUpdates} from "./RenderPendingUpdates";
import * as common from "../styles/common.module.scss";


export interface RenderSetDriversProps extends RendererProps {
    accounts: Account[];
    operationalMetricTypes: {id: string, name: string}[];
}

export function RenderSetDrivers(props: RenderSetDriversProps): ReactElement {
    const pendingUpdates = props.variables["pendingUpdates"];
    if(typeof pendingUpdates !== "object" || pendingUpdates === null) {
        return <></>;
    }

    return <div>
        <div className={common.textHeader}>{formatYearAndVersionType(props.variables["year"], props.variables["versionType"])}</div>
        <RenderPendingUpdates accounts={props.accounts} operationalMetricTypes={props.operationalMetricTypes} pendingUpdates={pendingUpdates} />
    </div>;
}